import React from 'react';
import './VideoLibrary.css';

import { PageTitle } from '../../../components';
import { videos } from '../../../constants';



const VideoLibrary = () => {

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={"Video Library"} page={"Video Library"} />

      {/* Video list section */}
      <section className="video-library">
        <div className="box-container">
          {/* Loop through each video from the videos array */}
          {videos.map((video, index) => (
            <div key={index} className="video-item">
              <figure className="video-container">
                <div className="responsive-video">
                  {/* Embedded YouTube iframe */}
                  <iframe
                    src={`https://www.youtube.com/embed/${video.id}`} // Dynamic video ID
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title={`YouTube video ${index + 1}`}
                  ></iframe>
                </div>
              </figure>
            </div>
          ))}
        </div>
      </section>
    </>

  );
};

export default VideoLibrary;